module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/visa-mastercard@2x_b508b5.png";